export const errorToast = {
    duration: 8000,
    position: 'bottom-left',
    style: {background: "linear-gradient( 180deg,rgb(68, 18, 3) 55.75%,rgba(82, 22, 22, 0.7) 100%)",
        color: "#FFF"},
    className: 'error-toast',
    icon: '⚠',
};

export const informationToast = {
    duration: 15000,
    position: 'bottom-left',
    style: {background: "#463FDF",
        color: "#FFF"},
    className: 'info-toast',
    icon: '🛈',
};

export const successToast = {
    duration: 7000,
    position: 'bottom-left',
    style: {background: "linear-gradient( 180deg,rgb(3, 71, 20) 55.75%,rgba(22, 82, 57, 0.7) 100%)",
        color: "#FFF"},
    className: 'success-toast',
    icon: '✓',
};
